// wishlist.js

window.initWishlistButtons = function () {
  const wishlist =
    JSON.parse(
      localStorage.getItem(`wishlist-items-${window.location.hostname}`)
    ) || [];
  const buttons = document.querySelectorAll("[data-wishlist-button]");

  buttons.forEach((button) => {
    const handle = button.getAttribute("data-handle");

    if (wishlist.includes(handle)) {
      button.classList.add("active");
      button.setAttribute("data-tooltip", "Remove from wishlist");
    } else {
      button.classList.remove("active");
      button.setAttribute("data-tooltip", "Add to wishlist");
    }

    // Remove old listeners if any (optional safe guard)
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    newButton.addEventListener("click", function () {
      let wishlist =
        JSON.parse(
          localStorage.getItem(`wishlist-items-${window.location.hostname}`)
        ) || [];
      const index = wishlist.indexOf(handle);

      if (index >= 0) {
        wishlist.splice(index, 1);
        newButton.classList.remove("active");
        newButton.setAttribute("data-tooltip", "Add to wishlist");
      } else {
        wishlist.push(handle);
        newButton.classList.add("active");
        newButton.setAttribute("data-tooltip", "Remove from wishlist");
      }

      localStorage.setItem(
        `wishlist-items-${window.location.hostname}`,
        JSON.stringify(wishlist)
      );
      const countSpan = document.querySelector(".wishlist-count");
      const bubble = document.querySelector(".wishlist-count-bubble");

      if (bubble && countSpan) {
        if (wishlist.length > 0) {
          countSpan.textContent = wishlist.length;
          bubble.style.display = "inline-block";
        } else {
          bubble.style.display = "none";
        }
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const WISHLIST_KEY = `wishlist-items-${window.location.hostname}`;

  // --- Utilities ---
  const getWishlist = () =>
    JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  const setWishlist = (items) =>
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));

  // --- Update wishlist count bubble in header ---
  const updateWishlistCount = () => {
    const wishlist = getWishlist();
    const bubble = document.querySelector(".wishlist-count-bubble");
    const countSpan = document.querySelector(".wishlist-count");

    if (!bubble || !countSpan) return;

    if (wishlist.length > 0) {
      countSpan.textContent = wishlist.length;
      bubble.style.display = "inline-block";
    } else {
      bubble.style.display = "none";
    }
  };

  // --- Toggle wishlist for a product handle ---
  const toggleWishlist = (handle, el) => {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(handle);

    if (index >= 0) {
      //the product was found
      wishlist.splice(index, 1);
      el.classList.remove("active");
      el.setAttribute("data-tooltip", "Add to wishlist");
    } else {
      wishlist.push(handle);
      el.classList.add("active");
      el.setAttribute("data-tooltip", "Remove from wishlist");
    }

    setWishlist(wishlist);
    updateWishlistCount();
  };

  // --- Initialize buttons ---
  // const initWishlistButtons = () => {
  //   const wishlist = getWishlist();
  //   const buttons = document.querySelectorAll("[data-wishlist-button]");

  //   buttons.forEach((button) => {
  //     const handle = button.getAttribute("data-handle");

  //     // Set initial state
  //     if (wishlist.includes(handle)) {
  //       button.classList.add("active");
  //       button.setAttribute("data-tooltip", "Remove from wishlist");
  //     } else {
  //       button.classList.remove("active");
  //       button.setAttribute("data-tooltip", "Add to wishlist");
  //     }

  //     // Event listener
  //     button.addEventListener("click", function () {
  //       toggleWishlist(handle, button);
  //     });
  //   });
  // };

  const renderWishlistPage = () => {
    const wishlistContainer = document.getElementById("wishlist-items");
    if (!wishlistContainer) return;

    const wishlist = getWishlist(); // from localStorage
    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    // Fetch matching product cards from a custom search view
    const query = wishlist.map((h) => "handle:" + h).join(" OR ");
    const url = `/search?q=${encodeURIComponent(query)}&view=cards`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const products = doc.querySelectorAll(".wishlist-card");
        console.log("pro", products);

        wishlistContainer.innerHTML = "";

        products.forEach((product) => {
          wishlistContainer.appendChild(product.cloneNode(true));
        });

        requestAnimationFrame(() => {
          initWishlistButtons();
        });
      });
  };

  // --- Initialization ---
  initWishlistButtons();
  updateWishlistCount();
  renderWishlistPage();
});
